import React from 'react'
import {config as cfg} from './config'
const outof195 = cfg.include.outof195 ? (await import('./apps/outof195')).outof195 : null
const aife = cfg.include.aife ? (await import('./apps/aife')).aife : null
const apps = [outof195, aife].filter(Boolean)

export const boot = {
    config: () => Promise.all(apps.map(({config}) => config?.() || Promise.resolve())),
    run: () => <>{apps.map(({name, run: Run}) => Run ? <Run key={name}/> : null)}</>,
    routes: () => apps.flatMap(({routes}) => routes?.() || []),
    content: () => <>{apps.map(({name, content: Content}) => Content ? <Content key={name}/> : null)}</>,
    hiddenContent: () => <>{apps.map(({name, hiddenContent: HiddenContent}) => HiddenContent ? <HiddenContent key={name}/> : null)}</>,
}
